import React from 'react';
import { SEO } from '../components/SEO';
import { UseCasesSection } from '../components/UseCasesSection';
import MainLayout from '../layouts/main';

export default () => {
  return (
    <MainLayout>
      <SEO
        pathname="/use-cases/"
        title="Publisher Use Cases"
        description="Growth tools and infrastructure for affiliate publishers of all stripes"
      />
      <UseCasesSection />
    </MainLayout>
  );
};
